module.exports = __webpack_public_path__ + "static/img/ie.297aaab8.png";